'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function (hex) {
	if (typeof hex !== 'string') {
		throw new TypeError('Expected a string');
	}

	hex = hex.replace(/^#/, '');

	if (hex.length === 3) {
		hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
	}

	var num = parseInt(hex, 16);

	return [num >> 16, num >> 8 & 255, num & 255];
};

; /* eslint-disable no-mixed-operators */


//////////////////
// WEBPACK FOOTER
// ./~/scroll-background/dist/utils/hex-rgb.js
// module id = 577
// module chunks = 0